import type { Event } from '../types/database';

/** Stored in events.inherit_from_parent without a dedicated column (no migration). */
export const CONTACT_INFO_ONLY_KEY = 'contact_info_only';

export function isContactInfoOnlyEvent(
  event: Pick<Event, 'inherit_from_parent'> | null | undefined
): boolean {
  return event?.inherit_from_parent?.[CONTACT_INFO_ONLY_KEY] === true;
}

export function buildInheritFromParentPayload(
  parentEventId: string | null,
  inheritFromParent: Record<string, boolean>,
  contactInfoOnly: boolean
): Record<string, boolean> | null {
  const payload = parentEventId ? { ...inheritFromParent } : {};

  if (contactInfoOnly) {
    payload[CONTACT_INFO_ONLY_KEY] = true;
  } else {
    delete payload[CONTACT_INFO_ONLY_KEY];
  }

  if (parentEventId) {
    return payload;
  }

  return contactInfoOnly ? payload : null;
}

/** Resolve a single phone value from profile columns (legacy home/work/cell). */
export function resolveProfilePhone(profile: {
  cell_phone?: string | null;
  home_phone?: string | null;
  work_phone?: string | null;
}): string {
  return profile.cell_phone?.trim() || profile.home_phone?.trim() || profile.work_phone?.trim() || '';
}

/** Map the unified form phone to cell_phone for storage (DB still has separate columns). */
export function phoneToProfileFields(phone: string): {
  cell_phone: string;
  home_phone: null;
  work_phone: null;
} {
  return {
    cell_phone: phone.trim(),
    home_phone: null,
    work_phone: null,
  };
}
